(function () {
  const loadingEl = document.getElementById('wiz-loading');
  const emptyEl = document.getElementById('wiz-empty');
  const formEl = document.getElementById('wiz-form');
  const fontEl = document.getElementById('wiz-font'); // native select (hidden)
  const sizeEl = document.getElementById('wiz-size');
  const editorEl = document.getElementById('wiz-editor');
  const previewStageEl = document.getElementById('wiz-preview-stage');
  const linesEl = document.getElementById('wiz-lines');
  const limitMsgEl = document.getElementById('wiz-limit-msg');
  const errorEl = document.getElementById('wiz-error');
  const saveBtn = document.getElementById('wiz-save');
  const previewEl = document.getElementById('wiz-preview');

  // Custom font picker elements
  const fontPickerEl = document.getElementById('wiz-font-picker');
  const fontCurrentBtn = document.getElementById('wiz-font-current');
  const fontListEl = document.getElementById('wiz-font-list');

  if (!formEl || !editorEl || !previewEl || !previewStageEl || !saveBtn) return;

  editorEl.setAttribute('data-placeholder', 'Enter your message here…');

  // Card Pack: make it explicit that one message prints inside every card.
  (function showPackMessageNote() {
    try {
      const itemType = (new URLSearchParams(window.location.search).get('item_type') || '').trim().toLowerCase();
      if (itemType !== 'card_pack') return;
      const note = document.createElement('p');
      note.className = 'wizard__pack-note';
      note.textContent = 'This message will be printed identically inside all 10 cards.';
      note.style.cssText = 'margin:0 0 18px;color:#6d6d6d;';
      // Place the note under the description in the right-hand options column,
      // pack pages only. Falls back to the editor if the layout changes.
      const right = document.querySelector('.wizard__right');
      const help = right ? right.querySelector('.wizard__help') : null;
      if (help) {
        help.insertAdjacentElement('afterend', note);
      } else if (right) {
        right.appendChild(note);
      } else if (editorEl && editorEl.parentElement) {
        editorEl.parentElement.insertBefore(note, editorEl);
      }
    } catch (e) {}
  })();

  const PROP = {
    UID: '_gigglz_uid',
    MESSAGE: '_gigglz_message',
    FONT: '_gigglz_font',
    SIZE: '_gigglz_text_size',
    FRONT_ASSET_KEY: '_gigglz_front_asset_key',
    BACK_ASSET_KEY: '_gigglz_back_asset_key',
    MESSAGE_PROFILE: '_gigglz_message_profile',
    RATE_PROFILE: '_gigglz_rate_profile',
    ITEM_TYPE: '_gigglz_item_type',
    PRODIGI_SKU: '_gigglz_prodigi_sku',
    PACK_SIZE: '_gigglz_pack_size',
    SEND_TO: '_gigglz_send_to',
    MESSAGE_PRESENT: '_gigglz_message_present'
  };

  // LocalStorage keys (used by cart/wizard entry)
  const LS = {
    SOURCE: 'gigglz_personalise_source',
    RETURN_TO: 'gigglz_personalise_return_to',
    LINE_KEY: 'gigglz_personalise_line_key'
  };

  // Suggest-a-message data lives in gigglz-suggest-messages.js (shared with Send List).
  const SUGGEST_MESSAGES = window.GigglzSuggestMessages.SUGGEST_MESSAGES;
  const SUGGEST_PROFILE_RULES = window.GigglzSuggestMessages.SUGGEST_PROFILE_RULES;
  const SUGGEST_DEFAULT_PROFILE = window.GigglzSuggestMessages.SUGGEST_DEFAULT_PROFILE;
  const SUGGEST_SS_PREFIX = window.GigglzSuggestMessages.SUGGEST_SS_PREFIX;

  // Captured from the cart line when editing an existing card, so
  // profile inference still has a signal in the edit-from-basket flow.
  let gigglzLoadedFrontKey = null;
  let gigglzLoadedMessageProfile = null; // product's message_profile metafield, from the cart line

  // Make the preview chrome clickable, without overriding native text selection/caret placement.
  previewEl.style.cursor = 'text';
  previewEl.addEventListener('click', (e) => {
    // Clicks that start inside the contenteditable editor must be left alone.
    // Otherwise the browser places the caret/selection correctly, then this
    // handler immediately collapses it back to the end of the message.
    if (editorEl.contains(e.target)) return;

    placeCaretAtEnd(editorEl);
  });

  // ---- Fonts ----
  // Typography and panel geometry live in gigglz-message-core.js (shared with Send List).
  const FONT_MAP = window.GigglzMessageCore.FONT_MAP;
  const FONT_LABELS = window.GigglzMessageCore.FONT_LABELS;
  const DEFAULT_FONT_KEY = window.GigglzMessageCore.DEFAULT_FONT_KEY;
  const SIZE_MAP = window.GigglzMessageCore.SIZE_MAP;
  const LINE_HEIGHT_MULTIPLIER = window.GigglzMessageCore.LINE_HEIGHT_MULTIPLIER;
  const PANEL_SPEC_MAP = window.GigglzMessageCore.PANEL_SPEC_MAP;
  const PREVIEW_MAX_WIDTH = 380;
  let currentRateProfile = '7x5';

  function qs() {
    return new URLSearchParams(window.location.search);
  }

  function getQueryLineParamRaw() {
    const v = qs().get('line');
    return v && v.trim().length ? v.trim() : null;
  }

  // If someone passes a numeric line (old flow), allow it.
  function getQueryLineNumber() {
    const raw = getQueryLineParamRaw();
    if (!raw) return null;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && String(n) === raw && n > 0 ? n : null;
  }

  // New flow: line item key (string like "abcd123:xyz")
  function getQueryLineKey() {
    const raw = getQueryLineParamRaw();
    if (!raw) return null;
    // If it looks purely numeric, treat it as a line number instead
    if (/^\d+$/.test(raw)) return null;
    return raw;
  }

  function getQueryVariant() {
    const v = qs().get('variant');
    const n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function getQueryQty() {
    const v = qs().get('qty');
    const n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function getQueryFrontAssetKey() {
    const v = qs().get('front_asset_key');
    return v && v.trim().length > 0 ? v.trim() : null;
  }

  function getQueryBackAssetKey() {
    const v = qs().get('back_asset_key');
    return v && v.trim().length > 0 ? v.trim() : null;
  }

  function getQueryRateProfile() {
    const v = qs().get('rate_profile');
    return v && v.trim().length > 0 ? v.trim() : null;
  }

  function getQueryItemType() {
    const v = qs().get('item_type');
    return v ? v.trim().toLowerCase() : '';
  }

  function isPackCreate() {
    return getQueryItemType() === 'card_pack';
  }

  function normaliseRateProfile(value) {
    const raw = String(value || '').trim().toLowerCase();
    if (raw === 'a4' || raw.includes('a4') || raw.includes('jumbo')) return 'a4';
    return '7x5';
  }

  function setCurrentRateProfile(value) {
    currentRateProfile = normaliseRateProfile(value);
    if (previewEl) previewEl.setAttribute('data-rate-profile', currentRateProfile);
    return currentRateProfile;
  }

  function getPanelSpec() {
    return PANEL_SPEC_MAP[currentRateProfile] || PANEL_SPEC_MAP['7x5'];
  }

  function applyPreviewSpec() {
    const spec = getPanelSpec();
    const parentWidth = previewEl.parentElement ? previewEl.parentElement.clientWidth : PREVIEW_MAX_WIDTH;
    const previewWidth = Math.min(PREVIEW_MAX_WIDTH, parentWidth || PREVIEW_MAX_WIDTH);
    const scale = previewWidth / spec.width;
    const previewHeight = Math.round(spec.height * scale);

    previewEl.style.setProperty('--wiz-preview-width', `${previewWidth}px`);
    previewEl.style.setProperty('--wiz-preview-height', `${previewHeight}px`);
    previewEl.style.setProperty('--wiz-panel-width', `${spec.width}px`);
    previewEl.style.setProperty('--wiz-panel-height', `${spec.height}px`);
    previewEl.style.setProperty('--wiz-panel-pad-x', `${spec.padX}px`);
    previewEl.style.setProperty('--wiz-panel-pad-y', `${spec.padY}px`);
    previewEl.style.setProperty('--wiz-scale', String(scale));
  }

  function getQueryUid() {
    const v = qs().get('uid');
    return v && v.trim().length > 0 ? v.trim() : null;
  }

  function getReturnUrlFromQuery() {
    const v = qs().get('return');
    return v && v.trim().length > 0 ? v : null;
  }

  // Optional (only if you ever decide to pass it): ?source=cart or ?source=wizard
  function getSourceFromQuery() {
    const v = qs().get('source');
    return v && v.trim().length > 0 ? v.trim() : null;
  }

  function getReturnUrlFromStorage() {
    try {
      const v = localStorage.getItem(LS.RETURN_TO);
      return v && v.trim().length > 0 ? v : null;
    } catch (e) {
      return null;
    }
  }

  function setReturnUrlInStorage(url) {
    try {
      if (url && url.trim().length > 0) localStorage.setItem(LS.RETURN_TO, url.trim());
    } catch (e) {}
  }

  function clearReturnUrlInStorage() {
    try {
      localStorage.removeItem(LS.RETURN_TO);
    } catch (e) {}
  }

  function getSafeSameOriginReferrer() {
    try {
      if (!document.referrer) return null;

      const ref = new URL(document.referrer, window.location.origin);

      if (ref.origin !== window.location.origin) return null;
      if (ref.pathname === window.location.pathname) return null;

      // Do not treat cart / delivery / checkout as "continue shopping" destinations
      if (
        ref.pathname === '/cart' ||
        ref.pathname === '/pages/delivery' ||
        ref.pathname === '/checkout' ||
        ref.pathname.startsWith('/checkout/')
      ) {
        return null;
      }

      return `${ref.pathname}${ref.search}${ref.hash}`;
    } catch (e) {
      return null;
    }
  }

  function primeCreateModeReturnUrl() {
    const fromQuery = getReturnUrlFromQuery();
    if (fromQuery) {
      setReturnUrlInStorage(fromQuery);
      return fromQuery;
    }

    const fromReferrer = getSafeSameOriginReferrer();
    if (fromReferrer) {
      setReturnUrlInStorage(fromReferrer);
      return fromReferrer;
    }

    // Important: avoid reusing a stale old value such as /pages/delivery
    clearReturnUrlInStorage();
    return null;
  }

  function setSourceInStorage(src) {
    try {
      if (src && src.trim().length > 0) localStorage.setItem(LS.SOURCE, src.trim());
    } catch (e) {}
  }

  function getStoredLineKey() {
    try {
      const v = localStorage.getItem(LS.LINE_KEY);
      return v && v.trim().length > 0 ? v.trim() : null;
    } catch (e) {
      return null;
    }
  }

  function setStoredLineKey(lineKey) {
    try {
      if (lineKey && lineKey.trim().length > 0) localStorage.setItem(LS.LINE_KEY, lineKey.trim());
    } catch (e) {}
  }

  function isUpdateMode() {
    const mode = (qs().get('mode') || '').toLowerCase();
    const hasVariant = !!getQueryVariant();
    if (hasVariant) return false;

    // Any of these imply "editing existing line item"
    const hasUid = !!getQueryUid();
    const hasLineNumber = !!getQueryLineNumber();
    const hasLineKey = !!getQueryLineKey();
    const hasStoredKey = !!getStoredLineKey();

    return mode === 'update' || hasUid || hasLineKey || hasStoredKey || hasLineNumber;
  }

  function makeUid() {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getContinueShoppingUrl() {
    return (
      getReturnUrlFromQuery() ||
      getSafeSameOriginReferrer() ||
      getReturnUrlFromStorage() ||
      '/collections/all'
    );
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not load cart');
    return res.json();
  }

  async function updateLineProperties(line, properties) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, properties })
    });
    if (!res.ok) throw new Error('Could not save message');
    return res.json();
  }

  async function addToCart(variantId, quantity, properties) {
    const cartUi = getCartUi();

    if (!cartUi || typeof cartUi.getSectionsToRender !== 'function') {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity, properties })
      });

      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to basket');
      }
      return data;
    }

    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity || 1));

    Object.entries(properties || {}).forEach(([key, value]) => {
      formData.append(`properties[${key}]`, value);
    });

    formData.append(
      'sections',
      cartUi
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);

    if (typeof cartUi.setActiveElement === 'function') {
      cartUi.setActiveElement(document.activeElement);
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    const data = await res.json();

    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add to basket');
    }

    return data;
  }

  function goSomewhereAfterSave() {
    const r = getReturnUrlFromQuery() || getReturnUrlFromStorage();
    if (r) {
      window.location.href = r;
      return;
    }
    // Default
    window.location.href = '/pages/delivery';
  }

  function openCartUiAfterAdd(response) {
    const cartUi = getCartUi();

    if (!cartUi || typeof cartUi.renderContents !== 'function') {
      goSomewhereAfterSave();
      return;
    }

    if (typeof cartUi.setActiveElement === 'function') {
      cartUi.setActiveElement(saveBtn);
    }

    cartUi.renderContents(response);

    if ((cartUi.tagName || '').toLowerCase() === 'cart-notification') {
      const continueBtn = cartUi.querySelector('.cart-notification__links .button-label');

      if (continueBtn) {
        const replacement = continueBtn.cloneNode(true);
        continueBtn.replaceWith(replacement);

        replacement.addEventListener('click', () => {
          window.location.href = getContinueShoppingUrl();
        });
      }
    }
  }

  // --- Text / empty-state helpers ---
  function normaliseText(raw) {
    return String(raw || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\u200B/g, '')
      .replace(/\r/g, '');
  }

  function stripOuterBlankLines(text) {
    return String(text || '')
      .replace(/^(?:[ \t]*\n)+/, '')
      .replace(/(?:\n[ \t]*)+$/, '');
  }

  function editorDomToText(root) {
    const parts = [];

    function walk(node) {
      if (!node) return;

      if (node.nodeType === Node.TEXT_NODE) {
        parts.push(node.nodeValue || '');
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const tag = node.tagName;

      if (tag === 'BR') {
        parts.push('\n');
        return;
      }

      const isBlock = tag === 'DIV' || tag === 'P' || tag === 'LI';
      const children = Array.from(node.childNodes || []);

      children.forEach((child) => walk(child));

      if (isBlock && parts.length) {
        const last = parts[parts.length - 1] || '';
        if (!last.endsWith('\n')) {
          parts.push('\n');
        }
      }
    }

    Array.from(root.childNodes || []).forEach((child) => walk(child));
    return parts.join('');
  }

  function getEditorPlainText() {
    const raw = editorDomToText(editorEl);
    const txt = stripOuterBlankLines(normaliseText(raw));
    return txt.trim() === '' ? '' : txt;
  }

  function getEditorText() {
    return getEditorPlainText();
  }

  function markEmpty(isEmpty) {
    editorEl.setAttribute('data-empty', isEmpty ? 'true' : 'false');
  }

  function isEffectivelyEmpty() {
    return getEditorText().length === 0;
  }

  function setEditorEmptyDom() {
    editorEl.innerHTML = '<br>';
  }

  function ensureEditableNotEmpty({ keepCaret = false } = {}) {
    if (!editorEl) return;

    if (isEffectivelyEmpty()) {
      setEditorEmptyDom();
      markEmpty(true);
      if (keepCaret) placeCaretAtEnd(editorEl);
    } else {
      markEmpty(false);
    }
  }

  function placeCaretAtEnd(el) {
    if (!el) return;
    el.focus();

    const sel = window.getSelection();
    if (!sel) return;

    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);

    sel.removeAllRanges();
    sel.addRange(range);
  }

  function setEditorText(text) {
    const t = stripOuterBlankLines(normaliseText(text));
    if (t.trim().length === 0) {
      setEditorEmptyDom();
      markEmpty(true);
    } else {
      editorEl.textContent = t;
      markEmpty(false);
    }
  }

  function normaliseFontKey(key) {
    return FONT_MAP[key] ? key : DEFAULT_FONT_KEY;
  }

  function applyTypography() {
    const fontKeyRaw = fontEl?.value || DEFAULT_FONT_KEY;
    const fontKey = normaliseFontKey(fontKeyRaw);

    const sizeKey = sizeEl?.value || 'Medium';
    let px = SIZE_MAP[sizeKey] || SIZE_MAP.Medium || 26;

    if (fontKey === 'font-scribble') {
      px = Math.round(px * 1.20);
    }

    const lh = Math.round(px * LINE_HEIGHT_MULTIPLIER);
    const fontFamily = FONT_MAP[fontKey] || 'inherit';

    editorEl.style.setProperty('--wiz-font-family', fontFamily);
    editorEl.style.setProperty('--wiz-font-size', px + 'px');
    editorEl.style.setProperty('--wiz-line-height', (lh / px).toFixed(3));
    editorEl.style.fontStyle = 'normal';
    editorEl.style.fontWeight = '400';

    if (fontCurrentBtn) {
      fontCurrentBtn.style.fontFamily = fontFamily;
      fontCurrentBtn.textContent = FONT_LABELS[fontKey] || fontKey;

      fontCurrentBtn.classList.remove(
        'font-classic', 'font-love', 'font-friendly', 'font-secret',
        'font-scribble', 'font-statement', 'font-christmas'
      );
      fontCurrentBtn.classList.add(fontKey);
    }

    if (fontEl && fontEl.value !== fontKey) {
      fontEl.value = fontKey;
    }
  }

  // Mirror for line counting (use HTML so blank lines count correctly)
  const mirror = document.createElement('div');
  mirror.style.position = 'absolute';
  mirror.style.top = '-99999px';
  mirror.style.left = '-99999px';
  mirror.style.visibility = 'hidden';
  mirror.style.pointerEvents = 'none';
  mirror.style.whiteSpace = 'pre-wrap';
  mirror.style.overflowWrap = 'anywhere';
  mirror.style.wordBreak = 'break-word';
  mirror.style.boxSizing = 'border-box';
  mirror.style.padding = '0';
  mirror.style.border = '0';
  document.body.appendChild(mirror);

  function updateLineCountAndLimit() {
    const editorStyle = window.getComputedStyle(editorEl);
    const spec = getPanelSpec();
    const innerWidth = spec.width - (spec.padX * 2);
    const innerHeight = spec.height - (spec.padY * 2);
    const measurementText = getEditorText();

    mirror.style.width = `${innerWidth}px`;
    mirror.style.fontFamily = editorStyle.fontFamily;
    mirror.style.fontSize = editorStyle.fontSize;
    mirror.style.lineHeight = editorStyle.lineHeight;
    mirror.style.fontWeight = editorStyle.fontWeight;
    mirror.style.fontStyle = editorStyle.fontStyle;
    mirror.style.letterSpacing = editorStyle.letterSpacing;
    mirror.style.textAlign = editorStyle.textAlign;
    mirror.style.whiteSpace = 'pre-wrap';
    mirror.style.overflowWrap = 'anywhere';
    mirror.style.wordBreak = 'break-word';

    mirror.textContent = measurementText;

    const lineHeightPx = parseFloat(editorStyle.lineHeight) || 1;
    const maxLines = Math.max(1, Math.floor((innerHeight + 0.5) / lineHeightPx));
    const usedHeight = measurementText ? mirror.getBoundingClientRect().height : 0;
    const usedLines = usedHeight === 0 ? 0 : Math.max(1, Math.round(usedHeight / lineHeightPx));

    if (linesEl) linesEl.textContent = `${usedLines} / ${maxLines} lines`;

    const tooLong = usedHeight > (innerHeight + 1);
    if (limitMsgEl) limitMsgEl.hidden = !tooLong;
    saveBtn.disabled = tooLong;

    return { usedLines, maxLines, tooLong };
  }

  function measureTextAgainstLimit(text) {
    const editorStyle = window.getComputedStyle(editorEl);
    const spec = getPanelSpec();
    const innerWidth = spec.width - (spec.padX * 2);
    const innerHeight = spec.height - (spec.padY * 2);
    const measurementText = stripOuterBlankLines(normaliseText(text));

    mirror.style.width = `${innerWidth}px`;
    mirror.style.fontFamily = editorStyle.fontFamily;
    mirror.style.fontSize = editorStyle.fontSize;
    mirror.style.lineHeight = editorStyle.lineHeight;
    mirror.style.fontWeight = editorStyle.fontWeight;
    mirror.style.fontStyle = editorStyle.fontStyle;
    mirror.style.letterSpacing = editorStyle.letterSpacing;
    mirror.style.textAlign = editorStyle.textAlign;
    mirror.style.whiteSpace = 'pre-wrap';
    mirror.style.overflowWrap = 'anywhere';
    mirror.style.wordBreak = 'break-word';

    mirror.textContent = measurementText;

    const usedHeight = measurementText ? mirror.getBoundingClientRect().height : 0;
    const tooLong = usedHeight > (innerHeight + 1);

    return { usedHeight, innerHeight, tooLong };
  }

  let limitFlashTimer = null;

  function flashLimitMessage() {
    updateLineCountAndLimit();

    if (limitMsgEl) {
      limitMsgEl.hidden = false;

      if (limitFlashTimer) clearTimeout(limitFlashTimer);
      limitFlashTimer = setTimeout(() => {
        updateLineCountAndLimit();
      }, 1800);
    }
  }

  // ---- Limit enforcement: snapshot rollback ----
  let lastGoodText = '';

  function snapshotIfGood() {
    lastGoodText = getEditorText();
  }

  function enforceLimitOnInput() {
    applyPreviewSpec();
    applyTypography();
    const { tooLong } = updateLineCountAndLimit();

    if (!tooLong) {
      snapshotIfGood();
      return;
    }

    setEditorText(lastGoodText);
    ensureEditableNotEmpty({ keepCaret: true });
    applyTypography();
    updateLineCountAndLimit();
  }

  function insertLineBreak() {
    const ok = (() => {
      try {
        return document.execCommand('insertLineBreak');
      } catch (e) {
        return false;
      }
    })();

    if (!ok) {
      const sel = window.getSelection();
      if (!sel || !sel.rangeCount) return;
      const range = sel.getRangeAt(0);
      range.deleteContents();
      const br = document.createElement('br');
      range.insertNode(br);
      range.setStartAfter(br);
      range.setEndAfter(br);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  // ---- Custom font picker wiring ----
  function closeFontList() {
    if (!fontListEl || !fontCurrentBtn) return;
    fontListEl.hidden = true;
    fontCurrentBtn.setAttribute('aria-expanded', 'false');
  }

  function openFontList() {
    if (!fontListEl || !fontCurrentBtn) return;
    fontListEl.hidden = false;
    fontCurrentBtn.setAttribute('aria-expanded', 'true');
    fontListEl.focus();
  }

  function toggleFontList() {
    if (!fontListEl) return;
    if (fontListEl.hidden) openFontList();
    else closeFontList();
  }

  function syncFontOptionStyles() {
    if (!fontListEl) return;
    const buttons = fontListEl.querySelectorAll('.wiz-font-option');
    const selectedKey = normaliseFontKey(fontEl?.value || DEFAULT_FONT_KEY);

    buttons.forEach((btn) => {
      const keyRaw = btn.getAttribute('data-font') || '';
      const key = normaliseFontKey(keyRaw);

      btn.style.fontFamily = FONT_MAP[key] || 'inherit';

      const isSelected = selectedKey === keyRaw || selectedKey === key;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  function setFontKey(key) {
    if (!fontEl) return;

    const nextKey = normaliseFontKey(key);
    fontEl.value = nextKey;

    fontEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (fontPickerEl && fontCurrentBtn && fontListEl) {
    fontCurrentBtn.addEventListener('click', () => toggleFontList());

    fontListEl.addEventListener('click', (e) => {
      const btn = e.target.closest('.wiz-font-option');
      if (!btn) return;
      const key = btn.getAttribute('data-font');
      setFontKey(key);
      closeFontList();
      placeCaretAtEnd(editorEl);
    });

    document.addEventListener('click', (e) => {
      if (!fontPickerEl.contains(e.target)) closeFontList();
    });

    fontCurrentBtn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openFontList();
      }
    });

    fontListEl.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeFontList();
        fontCurrentBtn.focus();
      }
    });
  }

  // ---- Helpers: resolve cart line number ----
  function setSaveCta() {
    saveBtn.textContent = isUpdateMode() ? 'Update text' : 'Add to basket';
  }

  async function findLineByUid(cart, uid) {
    if (!uid) return null;
    const items = cart.items || [];
    for (let i = 0; i < items.length; i++) {
      const p = items[i].properties || {};
      if (p[PROP.UID] === uid) return i + 1; // line number (1-based)
    }
    return null;
  }

  function findLineByKey(cart, key) {
    if (!key) return null;
    const items = cart.items || [];
    for (let i = 0; i < items.length; i++) {
      if (items[i] && items[i].key === key) return i + 1; // line number (1-based)
    }
    return null;
  }

  async function resolveLineToUse(cart) {
    const uid = getQueryUid();
    const queryKey = getQueryLineKey();
    const storedKey = getStoredLineKey();
    const queryLineNum = getQueryLineNumber();

    // Priority: UID > query key > stored key > query line number > 1
    if (uid) {
      const byUid = await findLineByUid(cart, uid);
      if (byUid) return byUid;
      return null;
    }

    if (queryKey) {
      const byKey = findLineByKey(cart, queryKey);
      if (byKey) return byKey;
      return null;
    }

    if (storedKey) {
      const byStored = findLineByKey(cart, storedKey);
      if (byStored) return byStored;
      // If stored key no longer exists, fall through
    }

    if (queryLineNum && cart.items && cart.items[queryLineNum - 1]) {
      return queryLineNum;
    }

    return (cart.items && cart.items.length) ? 1 : null;
  }

  // ---- Initial load ----
  let currentLine = null;
  setCurrentRateProfile(getQueryRateProfile() || previewEl.dataset.defaultRateProfile || '7x5');
  applyPreviewSpec();

  (async () => {
    try {
      // (1) Persist context if present in querystring
      const queryKey = getQueryLineKey();
      if (queryKey) setStoredLineKey(queryKey);

      const returnFromQuery = getReturnUrlFromQuery();
      if (returnFromQuery) setReturnUrlInStorage(returnFromQuery);

      const sourceFromQuery = getSourceFromQuery();
      if (sourceFromQuery) setSourceInStorage(sourceFromQuery);

      setEditorEmptyDom();
      markEmpty(true);
      snapshotIfGood();

      setSaveCta();

      const variantId = getQueryVariant();

      // CREATE MODE (PDP flow)
      if (variantId) {
        primeCreateModeReturnUrl();
        
        setCurrentRateProfile(getQueryRateProfile() || previewEl.dataset.defaultRateProfile || '7x5');

        if (fontEl) fontEl.value = DEFAULT_FONT_KEY;
        if (sizeEl) sizeEl.value = 'Medium';

        applyPreviewSpec();
        applyTypography();
        syncFontOptionStyles();
        updateLineCountAndLimit();
        snapshotIfGood();

        if (loadingEl) loadingEl.hidden = true;
        if (emptyEl) emptyEl.hidden = true;
        formEl.hidden = false;

        setTimeout(() => placeCaretAtEnd(editorEl), 0);
        return;
      }

      // EDIT/UPDATE MODE
      const cart = await getCart();
      if (!cart.items || cart.items.length === 0) {
        if (loadingEl) loadingEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      const lineToUse = await resolveLineToUse(cart);
      if (!lineToUse) throw new Error('That card is no longer in your basket.');

      currentLine = lineToUse;
      const currentItem = cart.items[currentLine - 1];
      const p = currentItem.properties || {};
      gigglzLoadedFrontKey = p[PROP.FRONT_ASSET_KEY] || gigglzLoadedFrontKey;
      gigglzLoadedMessageProfile = p[PROP.MESSAGE_PROFILE] || gigglzLoadedMessageProfile;

      setCurrentRateProfile(getQueryRateProfile() || p[PROP.RATE_PROFILE] || previewEl.dataset.defaultRateProfile || '7x5');

      const savedFont = p[PROP.FONT];
      if (fontEl) fontEl.value = normaliseFontKey(savedFont || DEFAULT_FONT_KEY);
      if (sizeEl) sizeEl.value = p[PROP.SIZE] || 'Medium';

      applyPreviewSpec();
      applyTypography();
      setEditorText(p[PROP.MESSAGE] || '');
      ensureEditableNotEmpty();

      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      formEl.hidden = false;

      syncFontOptionStyles();
      updateLineCountAndLimit();
      snapshotIfGood();
      setTimeout(() => placeCaretAtEnd(editorEl), 0);
    } catch (err) {
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = err.message || 'Something went wrong.';
      }
    }
  })();

  // ---- Live updates ----
  fontEl?.addEventListener('change', () => {
    applyPreviewSpec();
    applyTypography();
    syncFontOptionStyles();
    ensureEditableNotEmpty();
    updateLineCountAndLimit();
    snapshotIfGood();
    setSaveCta();
  });

  sizeEl?.addEventListener('change', () => {
    applyPreviewSpec();
    applyTypography();
    ensureEditableNotEmpty();
    updateLineCountAndLimit();
    snapshotIfGood();
    setSaveCta();
  });

  editorEl.addEventListener('focus', () => ensureEditableNotEmpty({ keepCaret: true }));
  editorEl.addEventListener('blur', () => ensureEditableNotEmpty());

  editorEl.addEventListener('beforeinput', (e) => {
    const type = e.inputType || '';

    // Prevent the common over-limit case before the browser inserts the character.
    // The existing input rollback remains as a safety net for paste, selection replacement
    // and browser edge cases.
    if (type !== 'insertText' || !e.data) return;

    const sel = window.getSelection();
    if (!sel || !sel.rangeCount || !sel.isCollapsed || !editorEl.contains(sel.anchorNode)) return;

    const candidateText = getEditorText() + e.data;
    if (measureTextAgainstLimit(candidateText).tooLong) {
      e.preventDefault();
      flashLimitMessage();
    }
  });

  editorEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const candidateText = `${getEditorText()}\n`;
      if (measureTextAgainstLimit(candidateText).tooLong) {
        flashLimitMessage();
        return;
      }

      insertLineBreak();
      ensureEditableNotEmpty({ keepCaret: true });
      enforceLimitOnInput();
      return;
    }

    if (e.key === 'Backspace' || e.key === 'Delete') {
      requestAnimationFrame(() => ensureEditableNotEmpty({ keepCaret: true }));
    }
  });

  editorEl.addEventListener('input', () => {
    ensureEditableNotEmpty();
    setSaveCta();
    enforceLimitOnInput();
  });

  editorEl.addEventListener('paste', () => {
    requestAnimationFrame(() => {
      ensureEditableNotEmpty();
      enforceLimitOnInput();
    });
  });

  editorEl.addEventListener('cut', () => {
    requestAnimationFrame(() => {
      ensureEditableNotEmpty({ keepCaret: true });
      enforceLimitOnInput();
    });
  });

  window.addEventListener('resize', () => {
    applyPreviewSpec();
    applyTypography();
    updateLineCountAndLimit();
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      applyPreviewSpec();
      applyTypography();
      updateLineCountAndLimit();
    }).catch(() => {});
  }

  // ---- Submit ----
  formEl.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;

    try {
      ensureEditableNotEmpty();
      const text = getEditorText();

      applyPreviewSpec();
      applyTypography();
      const { tooLong } = updateLineCountAndLimit();
      if (tooLong) return;

      saveBtn.disabled = true;

      const variantId = getQueryVariant();
      const qty = getQueryQty();

      // CREATE MODE
      if (variantId) {
        const props = { [PROP.UID]: makeUid() };
        props[PROP.RATE_PROFILE] = currentRateProfile;

        const frontAssetKey = getQueryFrontAssetKey();
        const backAssetKey = getQueryBackAssetKey();

        if (frontAssetKey) {
          props[PROP.FRONT_ASSET_KEY] = frontAssetKey;
        }

        if (backAssetKey) {
          props[PROP.BACK_ASSET_KEY] = backAssetKey;
        }

        // Persist the message profile (from the ?message_profile link param) onto the
        // cart line, so a later edit-from-basket keeps the same suggestions.
        const messageProfile = (qs().get('message_profile') || '').trim();
        if (messageProfile) {
          props[PROP.MESSAGE_PROFILE] = messageProfile;
        }

        if (text.trim().length > 0) {
          props[PROP.MESSAGE] = text;
          props[PROP.FONT] = normaliseFontKey(fontEl?.value || DEFAULT_FONT_KEY);
          props[PROP.SIZE] = sizeEl?.value || 'Medium';
        }

        if (isPackCreate()) {
          props[PROP.ITEM_TYPE] = 'card_pack';
          const packSku = (qs().get('prodigi_sku') || '').trim();
          if (packSku) props[PROP.PRODIGI_SKU] = packSku;
          const packSize = (qs().get('pack_size') || '').trim();
          if (packSize) props[PROP.PACK_SIZE] = packSize;
          // Keep the pack rate profile verbatim (e.g. 7x5_pack), not the normalised 7x5.
          props[PROP.RATE_PROFILE] = getQueryRateProfile() || '7x5_pack';
          props[PROP.SEND_TO] = 'me';
          props[PROP.MESSAGE_PRESENT] = text.trim().length > 0 ? 'true' : 'false';
        }

        const response = await addToCart(variantId, qty, props);
        openCartUiAfterAdd(response);
        return;
      }

      // UPDATE MODE
      const cart = await getCart();
      if (!cart.items || cart.items.length === 0) throw new Error('Your basket is empty.');

      const lineToUse = await resolveLineToUse(cart);
      if (!lineToUse) throw new Error('That card is no longer in your basket.');

      const currentItem = cart.items[lineToUse - 1];
      if (!currentItem) throw new Error('That item is no longer in your basket.');

      const existing = currentItem.properties || {};
      const nextProps = Object.assign({}, existing);

      // Ensure UID exists on the line
      if (!nextProps[PROP.UID]) nextProps[PROP.UID] = makeUid();
      nextProps[PROP.RATE_PROFILE] = currentRateProfile;

      if (existing[PROP.ITEM_TYPE] === 'card_pack') {
        nextProps[PROP.ITEM_TYPE] = 'card_pack';
        // Preserve the pack rate profile; do not overwrite with the normalised 7x5.
        nextProps[PROP.RATE_PROFILE] = existing[PROP.RATE_PROFILE] || getQueryRateProfile() || '7x5_pack';
        nextProps[PROP.SEND_TO] = 'me';
        nextProps[PROP.MESSAGE_PRESENT] = text.trim().length > 0 ? 'true' : 'false';
      }

      if (text.trim().length > 0) {
        nextProps[PROP.MESSAGE] = text;
        nextProps[PROP.FONT] = normaliseFontKey(fontEl?.value || DEFAULT_FONT_KEY);
        nextProps[PROP.SIZE] = sizeEl?.value || 'Medium';
      } else {
        delete nextProps[PROP.MESSAGE];
        delete nextProps[PROP.FONT];
        delete nextProps[PROP.SIZE];
      }

      await updateLineProperties(lineToUse, nextProps);
      goSomewhereAfterSave();
    } catch (err) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = err.message || 'Could not save. Please try again.';
      }
    } finally {
      saveBtn.disabled = false;
      setSaveCta();
    }
  });

  // ============================================================
  // Suggest a message — behaviour
  // Drops a curated message for the current occasion profile into
  // the existing editor, then runs the normal preview / line-count
  // / limit / snapshot / save-CTA updates so it behaves exactly
  // like typed text and stays fully editable.
  //
  // No network requests: every message lives in the bank above and
  // selection happens entirely in the browser. Sequencing (shuffle,
  // then no repeat until the profile is exhausted) is remembered
  // per profile in sessionStorage, so a refresh or return visit
  // does not restart the order.
  // ============================================================
  (function initSuggestMessage() {
    const suggestBtn = document.getElementById('wiz-suggest-message');
    const suggestStatus = document.getElementById('wiz-suggest-status');

    // Defensive: if the button is not on the page, do nothing.
    if (!suggestBtn) return;

    const LABEL_INITIAL = 'Suggest a message';
    const LABEL_MORE = 'Try another';

    let resolvedProfile = null;   // cached after first use
    let lastSuggestedText = null; // exact text we last inserted
    let hasSuggested = false;

    function announce(msg, isWarning) {
      if (!suggestStatus) return;
      suggestStatus.textContent = msg || '';
      suggestStatus.classList.toggle('wizard__suggest-status--warn', !!isWarning);
    }

    // Context we can infer the occasion from, all lower-cased.
    function buildContextString() {
      const parts = [
        getQueryFrontAssetKey() || '',
        gigglzLoadedFrontKey || '',
        qs().get('return') || '',
        document.referrer || ''
      ];
      return parts.join(' ').toLowerCase();
    }

    // Priority: explicit ?message_profile > product metafield > inferred > general.
    function resolveProfile() {
      const explicit = (qs().get('message_profile') || '').trim().toLowerCase();
      if (explicit && SUGGEST_MESSAGES[explicit]) return explicit;

      // 2. Product's message_profile metafield, carried on the cart line.
      const fromProduct = (gigglzLoadedMessageProfile || '').trim().toLowerCase();
      if (fromProduct && SUGGEST_MESSAGES[fromProduct]) return fromProduct;

      const ctx = buildContextString();
      for (let i = 0; i < SUGGEST_PROFILE_RULES.length; i++) {
        const rule = SUGGEST_PROFILE_RULES[i];
        for (let k = 0; k < rule.keywords.length; k++) {
          if (ctx.indexOf(rule.keywords[k]) !== -1) return rule.profile;
        }
      }
      return SUGGEST_DEFAULT_PROFILE;
    }

    function getProfile() {
      if (!resolvedProfile) {
        resolvedProfile = resolveProfile();
        if (!SUGGEST_MESSAGES[resolvedProfile]) resolvedProfile = SUGGEST_DEFAULT_PROFILE;
      }
      return resolvedProfile;
    }

    // Fisher-Yates shuffle of [0..n-1].
    function shuffle(n) {
      const arr = [];
      for (let i = 0; i < n; i++) arr.push(i);
      for (let i = n - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const t = arr[i];
        arr[i] = arr[j];
        arr[j] = t;
      }
      return arr;
    }

    function readSeq(profile, n) {
      let order = null;
      let pos = 0;
      try {
        const rawOrder = sessionStorage.getItem(SUGGEST_SS_PREFIX + 'order_' + profile);
        const rawPos = sessionStorage.getItem(SUGGEST_SS_PREFIX + 'pos_' + profile);
        if (rawOrder) {
          const parsed = JSON.parse(rawOrder);
          // Only trust a stored order that covers exactly 0..n-1 once each.
          if (Array.isArray(parsed) && parsed.length === n) {
            const seen = new Array(n).fill(false);
            let ok = true;
            for (let i = 0; i < parsed.length; i++) {
              const v = parsed[i];
              if (typeof v !== 'number' || v < 0 || v >= n || seen[v]) { ok = false; break; }
              seen[v] = true;
            }
            if (ok) order = parsed;
          }
        }
        if (rawPos !== null) {
          const p = parseInt(rawPos, 10);
          if (Number.isFinite(p) && p >= 0) pos = p;
        }
      } catch (e) { /* sessionStorage unavailable: fall back to a fresh order */ }

      if (!order) { order = shuffle(n); pos = 0; }
      return { order: order, pos: pos };
    }

    function saveSeq(profile, order, pos) {
      try {
        sessionStorage.setItem(SUGGEST_SS_PREFIX + 'order_' + profile, JSON.stringify(order));
        sessionStorage.setItem(SUGGEST_SS_PREFIX + 'pos_' + profile, String(pos));
      } catch (e) { /* ignore */ }
    }

    // Does this text fit the current font and size? Uses the
    // existing measurement helper against the live editor styles.
    function fits(text) {
      applyTypography();
      return !measureTextAgainstLimit(text).tooLong;
    }

    // Next fitting message index for a profile, without repeating
    // until the profile is exhausted. Returns null if nothing in
    // the profile fits the current font size.
    function pickNextIndex(profile, list) {
      const n = list.length;
      if (!n) return null;

      let seq = readSeq(profile, n);
      let order = seq.order;
      let pos = seq.pos;
      let chosen = null;
      let lastIdx = -1;

      for (let tried = 0; tried < n; tried++) {
        if (pos >= order.length) {
          // Exhausted: reshuffle, avoiding an immediate repeat of the last shown.
          const next = shuffle(n);
          if (n > 1 && next[0] === lastIdx) {
            const t = next[0];
            next[0] = next[1];
            next[1] = t;
          }
          order = next;
          pos = 0;
        }
        const idx = order[pos];
        pos++;
        lastIdx = idx;
        if (fits(list[idx])) { chosen = idx; break; }
      }

      saveSeq(profile, order, pos);
      return chosen;
    }

    // Insert text using the existing editor helper and run the same
    // update sequence the font/size change handlers use.
    function insertSuggestion(text) {
      setEditorText(text);
      ensureEditableNotEmpty();
      applyPreviewSpec();
      applyTypography();
      updateLineCountAndLimit();
      snapshotIfGood();
      setSaveCta();
      lastSuggestedText = getEditorText();
    }

    function doSuggest() {
      const profile = getProfile();
      const list = SUGGEST_MESSAGES[profile] || SUGGEST_MESSAGES[SUGGEST_DEFAULT_PROFILE] || [];
      const idx = pickNextIndex(profile, list);

      if (idx === null) {
        announce('That’s a lot of card for this size. Try a smaller font size to see suggestions.', true);
        return;
      }

      insertSuggestion(list[idx]);

      if (!hasSuggested) {
        hasSuggested = true;
        suggestBtn.textContent = LABEL_MORE;
        announce('Here’s a suggestion. You can edit it in the card.', false);
      } else {
        announce('Here’s another suggestion.', false);
      }
    }

    function handleClick() {
      const text = getEditorText();

      // Empty editor: insert straight away.
      if (text.length === 0) { doSuggest(); return; }

      // Unedited previous suggestion: replace straight away.
      if (lastSuggestedText !== null && text === lastSuggestedText) { doSuggest(); return; }

      // Customer-written text, or a suggestion they have edited:
      // confirm before replacing. Cancelling preserves it exactly.
      const ok = window.confirm('Replace your current message with a new suggestion?');
      if (!ok) return;
      doSuggest();
    }

    suggestBtn.addEventListener('click', handleClick);
  })();

})();